import { CONTACT } from "@/lib/constants";

export default function Terms() {
    return (
        <div data-testid="terms-page" className="container-tight py-16 md:py-24 max-w-3xl">
            <div className="eyebrow">Legal</div>
            <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter text-white mt-3">Terms of Service</h1>
            <p className="text-zinc-500 mt-3 text-sm">Last updated: February 19, 2026</p>

            <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed">
                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">1. Acceptance</h2>
                    <p>
                        By accessing or using All About Printers (the &quot;Site&quot;), you agree to be bound by these
                        Terms of Service. If you do not agree, please do not use the Site.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">2. Editorial independence</h2>
                    <p>
                        Reviews and recommendations on this Site reflect the independent editorial opinion of our team,
                        based on manufacturer specifications, published documentation, and independent research.
                        We retain full editorial control and are not sponsored by or affiliated with any brand unless
                        expressly and clearly stated in a specific piece of content.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">3. No warranty</h2>
                    <p>
                        All content is provided &quot;as is&quot; for informational purposes only. Specifications, pricing,
                        and availability change frequently and may not be current. Always confirm details with the
                        manufacturer or retailer before purchasing.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">4. Affiliate relationships</h2>
                    <p>
                        We may earn a commission when readers click affiliate links and make a purchase.
                        This does not affect the price you pay or our editorial rankings.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">5. Limitation of liability</h2>
                    <p>
                        To the maximum extent permitted by law, All About Printers is not liable for any indirect,
                        incidental, or consequential damages arising from your use of the Site or reliance on its content.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">6. Intellectual property</h2>
                    <p>
                        All original content (text, images, and layouts) is © All About Printers, unless otherwise credited.
                        Product images and brand names are the property of their respective owners and used editorially under fair use.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">7. Prohibited use</h2>
                    <p>
                        You may not use the Site to distribute malware, scrape data at abusive rates, or submit
                        misleading or fraudulent information through the contact form.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">8. Changes</h2>
                    <p>
                        We may update these terms at any time. Continued use of the Site after a change means you accept the revised terms.
                    </p>
                </section>

                <section>
                    <h2 className="font-display text-xl font-semibold text-white mb-3">9. Contact</h2>
                    <p>
                        Questions? Reach us at {CONTACT.email} or {CONTACT.phoneDisplay}.
                    </p>
                </section>
            </div>
        </div>
    );
}
